import { render, staticRenderFns } from "./frontFooterNew.vue?vue&type=template&id=58ee7be6&scoped=true&"
import script from "./frontFooterNew.vue?vue&type=script&lang=js&"
export * from "./frontFooterNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee7be6",
  null
  
)

export default component.exports